"use client";

import { LabelList, RadialBar, RadialBarChart } from "recharts";
import {
  type ChartConfig,
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "visuais";

interface RadialChartData {
  [key: string]: any;
  fill: string;
}

interface RadialChartProps {
  data: RadialChartData[];
  config: ChartConfig;
  startAngle?: number;
  endAngle?: number;
  innerRadius?: number;
  outerRadius?: number;
  className?: string;
  dataKey?: string;
  showLabels?: boolean;
  showTooltip?: boolean;
  nameKey?: string;
}

/**
 * Componente RadialChart genérico igual ao shadcn
 * Suporta múltiplas barras concêntricas com labels
 */
export function RadialChart({
  data,
  config,
  startAngle = -90,
  endAngle = 380,
  innerRadius = 30,
  outerRadius = 110,
  className = "mx-auto aspect-square max-h-[250px]",
  dataKey = "visitors",
  showLabels = true,
  showTooltip = true,
  nameKey = "metrica",
}: RadialChartProps) {
  return (
    <ChartContainer config={config} className={className}>
      <RadialBarChart
        data={data}
        startAngle={startAngle}
        endAngle={endAngle}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
      >
        {showTooltip && (
          <ChartTooltip
            cursor={false}
            content={<ChartTooltipContent hideLabel nameKey={nameKey} />}
          />
        )}
        <RadialBar dataKey={dataKey} background>
          {showLabels && (
            <LabelList
              position="insideStart"
              dataKey={nameKey}
              className="fill-white capitalize mix-blend-luminosity"
              fontSize={11}
            />
          )}
        </RadialBar>
      </RadialBarChart>
    </ChartContainer>
  );
}

// Exportar também como GenericRadialChart para compatibilidade
export { RadialChart as GenericRadialChart };
